import React, { createContext, useState } from 'react';

const ModalContext = createContext();
export default ModalContext;

const { Provider } = ModalContext;

const ModalProvider = ({ children }) => {
  const [isOnModal, setIsOnModal] = useState(false);
  const [isButtonAvailable, setIsButtonAvailable] = useState(true);
  const [modalContent, setModalContent] = useState({
    title: '',
    text: '',
    content: '',
    buttonText: '',
    afterConfirmEvent: () => {},
    afterCloseEvent: () => {},
  });

  const onCloseModal = () => {
    setIsOnModal(false);
    modalContent.afterCloseEvent && modalContent.afterCloseEvent();
  };

  const onConfirmModal = () => {
    setIsOnModal(false);
    modalContent.afterConfirmEvent && modalContent.afterConfirmEvent();
  };

  const onModal = (content) => {
    setIsOnModal(true);
    setIsButtonAvailable(true);
    setModalContent(content);
  };

  const context = {
    state: {
      isOnModal,
      modalContent,
      isButtonAvailable,
    },
    actions: {
      onModal,
      onCloseModal,
      onConfirmModal,
      setIsButtonAvailable,
    },
  };

  return <Provider value={context}>{children}</Provider>;
};

export { ModalProvider };
